(function () {
  'use strict';

  var grid = document.getElementById('WishlistGrid');
  var emptyState = document.getElementById('WishlistEmptyState');
  var loading = document.getElementById('WishlistLoading');
  if (!grid) return;

  function extractHandle(url) {
    try {
      var parts = new URL(url, window.location.origin).pathname.split('/').filter(Boolean);
      var idx = parts.indexOf('products');
      return idx !== -1 ? parts[idx + 1] : null;
    } catch (e) {
      return null;
    }
  }

  function loadCard(handle) {
    const root = window.Shopify?.routes?.root || '/';
    return fetch(`${root}products/${handle}?section_id=product-card-ajax`)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('gz-product-card');
      })
      .catch(function () { return null; });
  }

  function showEmpty() {
    grid.classList.add('hidden');
    if (emptyState) emptyState.classList.remove('hidden');
  }

  var hasLoaded = false;
  var fallbackTimeout = setTimeout(function() {
    if (!hasLoaded) {
      if (loading) loading.classList.add('hidden');
      showEmpty();
    }
  }, 5000);

  function render(items) {
    hasLoaded = true;
    if (loading) loading.classList.add('hidden');

    if (!items.length) {
      showEmpty();
      return;
    }

    // Hide the empty state if it was shown by the timeout fallback
    if (emptyState) emptyState.classList.add('hidden');

    var handles = items.map(function (item) { return extractHandle(item.du); }).filter(Boolean);

    Promise.all(handles.map(loadCard)).then(function (cards) {
      cards.forEach(function (card) {
        if (card) grid.appendChild(card);
      });

      if (!grid.querySelector('[data-item-id]')) {
        showEmpty();
        return;
      }

      grid.classList.remove('hidden');

      grid.querySelectorAll('.js-wishlist-toggle').forEach(function (btn) {
        btn.classList.remove('invisible');
        btn.setAttribute('aria-pressed', 'true');
      });

      window.GZAnalyticsQueue = window.GZAnalyticsQueue || [];
      window.GZAnalyticsQueue.push(function (GZAnalytics) {
        GZAnalytics.pushViewItemListFromContainer('#WishlistGrid', 'wishlist');
      });
    });
  }

  grid.addEventListener('wishlist:changed', function (e) {
    if (e.detail.wishlisted) return;
    var card = e.target.closest('[data-item-id="' + e.detail.empi + '"]');
    if (card) card.remove();
    if (!grid.querySelector('[data-item-id]')) showEmpty();
  });

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    swat.fetchLists({
      callbackFn: function (lists) {
        window.swymWishLists = lists;
        window.swymSelectedListId = lists && lists[0] && lists[0].lid;
        render((lists && lists[0] && lists[0].listcontents) || []);
      },
      errorFn: function () {
        hasLoaded = true;
        if (loading) loading.classList.add('hidden');
        showEmpty();
      }
    });
  });
})();
